/* eslint-disable hubspot-dev/no-private-classes */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Icon", "icon", "value"],
  _excluded2 = ["open", "options", "value"];
import { AbstractDropdown } from 'foundations-components/transitional/components/AbstractDropdown';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { moveFocusToNext } from 'foundations-components/transitional/utils/dom';
import { uniqueId } from 'foundations-components/transitional/utils/uniqueId';
import styled from 'foundations-theming/utils';
import { Component } from 'react';
import memoize from 'react-utils/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIconWrapper = styled.div.withConfig({
  displayName: "UIAbstractIconDropdown__StyledIconWrapper",
  componentId: "sc-1joa3ky-0"
})(({
  theme
}) => ({
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: theme.color['fill-field-hover']
  }
}));
class UIAbstractIconDropdown extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = evt => {
      const {
        key
      } = evt;
      const {
        open
      } = this.props;
      if (!open) return;
      if (key === 'ArrowDown' || key === 'ArrowUp') {
        const menu = document.getElementById(this._id);
        if (!menu) return;
        if (moveFocusToNext('li', menu, key === 'ArrowUp')) {
          evt.preventDefault();
        }
        evt.stopPropagation();
      }
    };
    this._id = `icon-dropdown-${uniqueId()}`;
    this.getHandleChange = memoize(this.getHandleChange.bind(this));
  }
  getHandleChange(value) {
    const event = syntheticEvent(value);
    return () => {
      const {
        onOpenChange,
        onChange,
        open
      } = this.props;
      onChange(event);
      onOpenChange(syntheticEvent(!open));
    };
  }
  renderOptions(options) {
    return options.map(_ref => {
      let {
          Icon,
          icon,
          value
        } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);
      return /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(StyledIconWrapper, {
          children: /*#__PURE__*/_jsx(IconButton, Object.assign({}, rest, {
            onClick: this.getHandleChange(value),
            placement: "right",
            use: "transparent",
            size: "small",
            marginInline: "200",
            paddingBlock: "300",
            paddingInline: "200",
            children: /*#__PURE__*/_jsx(Icon, {
              color: "icon-core-default"
            })
          }))
        })
      }, icon);
    });
  }
  render() {
    const _this$props = this.props,
      {
        open,
        options
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded2);
    return /*#__PURE__*/_jsx(AbstractDropdown, Object.assign({}, rest, {
      menuWidth: 48,
      open: open,
      onKeyDown: this.handleKeyDown,
      children: /*#__PURE__*/_jsx(List, {
        paddingBlock: "200",
        id: this._id,
        children: this.renderOptions(options)
      })
    }));
  }
}
UIAbstractIconDropdown.displayName = 'UIAbstractIconDropdown';
export default UIAbstractIconDropdown;